module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product2-3b93c2cf466232a2539ca9ff5a000c4d.jpg";